import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {storage} from '@/config'
// 使用vuex
Vue.use(Vuex)
// 读取指定文件目录下的文件
const file_list = require.context('./modules', true, /\.js$/)


const modules = file_list.keys().reduce((res, key) => {
    // 获取文件名
    let key_name = key.replace(/(\.\/|\.js)/g, '');
    res[key_name] = file_list(key).default;
    res[key_name]['namespaced'] = true;
    return res;
}, [])


console.log(modules)
export default new Vuex.Store({
    modules,
    // plugins: [createPersistedState({
    //     paths: ['app.formData'],
    //     key: 'app-formData',
    //     storage: 'sessionStorage',
    // })],
})
